module.exports = __webpack_public_path__ + "img/dk.a14fa253.png";